/* ============================================================
   MARKET DWELLINGS — Product Page V2 JavaScript
   File: assets/md-product-v2.js
   ============================================================ */

(function () {
  'use strict';

  const D = window.mdProductData;
  if (!D) return;

  const variants      = D.variants;
  const options        = D.options;       // array of option names
  const minQty         = D.minQty || 1;
  const setSize        = D.setSize || 1;
  const isSetProduct   = D.isSetProduct;
  const productUnit    = D.productUnit || '';
  const swatchOption   = D.swatchOption || '';
  const productTitle   = D.productTitle || '';
  const recommendedQty = D.recommendedQty || '';
  const variantDescs   = (typeof D.variantDescriptions === 'string')
    ? tryParse(D.variantDescriptions) : (D.variantDescriptions || {});

  // Current selections: { "Material": "Corrugated Plastic", "Quantity": "10" }
  const selected = {};

  // Identify which option is the "quantity" option
  const qtyKeywords = ['quantity', 'qty', 'units', 'sets', 'pack', 'packs'];
  let qtyOptionName = null;
  options.forEach(name => {
    const lower = name.toLowerCase();
    qtyKeywords.forEach(kw => {
      if (lower.includes(kw)) qtyOptionName = name;
    });
  });

  // ── SVG GRAPHICS MAP ────────────────────────────────────
  const variantGraphics = {
    'corrugated-plastic': '<svg width="28" height="28" viewBox="0 0 28 28" fill="none"><line x1="5" y1="4" x2="5" y2="24" stroke="currentColor" stroke-width="1.4" opacity="0.5"/><line x1="9" y1="4" x2="9" y2="24" stroke="currentColor" stroke-width="1.4" opacity="0.5"/><line x1="13" y1="4" x2="13" y2="24" stroke="currentColor" stroke-width="1.4" opacity="0.5"/><line x1="17" y1="4" x2="17" y2="24" stroke="currentColor" stroke-width="1.4" opacity="0.5"/><line x1="21" y1="4" x2="21" y2="24" stroke="currentColor" stroke-width="1.4" opacity="0.5"/></svg>',
    'pvc': '<svg width="28" height="28" viewBox="0 0 28 28" fill="none"><rect x="4" y="4" width="20" height="20" rx="3" fill="#e8e3da" opacity="0.5"/><rect x="4" y="4" width="20" height="20" rx="3" stroke="currentColor" stroke-width="1"/></svg>',
    'aluminum-composite': '<svg width="28" height="28" viewBox="0 0 28 28" fill="none"><defs><linearGradient id="acm" x1="0" y1="0" x2="28" y2="28"><stop offset="0%" stop-color="#ccc"/><stop offset="50%" stop-color="#eee"/><stop offset="100%" stop-color="#aaa"/></linearGradient></defs><rect x="4" y="4" width="20" height="20" rx="3" fill="url(#acm)"/><rect x="4" y="4" width="20" height="20" rx="3" stroke="#999" stroke-width="1"/></svg>',
    'no-holes': '<svg width="30" height="14" viewBox="0 0 30 14" fill="none"><rect x="1" y="1" width="28" height="12" rx="2" stroke="currentColor" stroke-width="1.3" fill="rgba(88,165,137,0.04)"/></svg>',
    '2-top-holes': '<svg width="30" height="14" viewBox="0 0 30 14" fill="none"><rect x="1" y="1" width="28" height="12" rx="2" stroke="currentColor" stroke-width="1.3" fill="rgba(0,0,0,0.02)"/><circle cx="9" cy="4.5" r="1.8" fill="none" stroke="currentColor" stroke-width="1"/><circle cx="21" cy="4.5" r="1.8" fill="none" stroke="currentColor" stroke-width="1"/></svg>',
    '2-top-2-bottom-holes': '<svg width="30" height="14" viewBox="0 0 30 14" fill="none"><rect x="1" y="1" width="28" height="12" rx="2" stroke="currentColor" stroke-width="1.3" fill="rgba(0,0,0,0.02)"/><circle cx="9" cy="4" r="1.6" fill="none" stroke="currentColor" stroke-width="1"/><circle cx="21" cy="4" r="1.6" fill="none" stroke="currentColor" stroke-width="1"/><circle cx="9" cy="10" r="1.6" fill="none" stroke="currentColor" stroke-width="1"/><circle cx="21" cy="10" r="1.6" fill="none" stroke="currentColor" stroke-width="1"/></svg>',
  };

  // ── INIT ──────────────────────────────────────────────────

  function init() {
    // Set initial selections from first variant
    options.forEach((name, i) => {
      const firstVariant = variants[0];
      if (firstVariant) {
        selected[name] = firstVariant['option' + (i + 1)];
      }
    });

    // Mark initial active — standard buttons
    document.querySelectorAll('.md-style-btn').forEach(btn => {
      const optName = btn.dataset.option;
      if (selected[optName] === btn.dataset.value) {
        btn.classList.add('active');
      } else {
        btn.classList.remove('active');
      }
    });

    // Mark initial active — swatch buttons
    document.querySelectorAll('.md-swatch-btn').forEach(btn => {
      const optName = btn.dataset.option;
      if (selected[optName] === btn.dataset.value) {
        btn.classList.add('active');
      } else {
        btn.classList.remove('active');
      }
    });

    // Set initial dropdown value
    const qtySelect = document.getElementById('md-qty-select');
    if (qtySelect && qtyOptionName && selected[qtyOptionName]) {
      qtySelect.value = selected[qtyOptionName];
    }

    // Populate variant descriptions and graphics
    populateVariantDescriptions();
    populateVariantGraphics();

    // Bind events
    bindStyleButtons();
    bindSwatchButtons();
    bindQtySelect();
    bindThumbnails();
    bindTabs();
    bindFaq();

    // Render initial state
    updateVariant();
    buildBulkPanel();
    filterImagesByVariant();
  }

  // ── VARIANT DESCRIPTIONS ──────────────────────────────────

  function populateVariantDescriptions() {
    document.querySelectorAll('.md-style-btn-desc').forEach(el => {
      const value = el.dataset.descFor;
      if (variantDescs && variantDescs[value]) {
        el.textContent = variantDescs[value];
        el.classList.add('has-desc');
      }
    });
  }

  // ── VARIANT GRAPHICS ──────────────────────────────────────

  function populateVariantGraphics() {
    document.querySelectorAll('.md-style-btn-graphic').forEach(el => {
      const handle = el.dataset.graphicFor;
      if (handle && variantGraphics[handle]) {
        el.innerHTML = variantGraphics[handle];
        el.classList.add('has-graphic');
      } else {
        el.style.display = 'none';
      }
    });
  }

  // ── STYLE BUTTON EVENTS ──────────────────────────────────

  function bindStyleButtons() {
    document.querySelectorAll('.md-style-btn').forEach(btn => {
      btn.addEventListener('click', () => {
        const optName = btn.dataset.option;
        const optVal = btn.dataset.value;
        selected[optName] = optVal;

        const grid = btn.closest('.md-style-grid');
        grid.querySelectorAll('.md-style-btn').forEach(b => b.classList.remove('active'));
        btn.classList.add('active');

        updateVariant();
        buildBulkPanel();
        filterImagesByVariant();
      });
    });
  }

  // ── SWATCH BUTTON EVENTS ─────────────────────────────────

  function bindSwatchButtons() {
    document.querySelectorAll('.md-swatch-btn').forEach(btn => {
      btn.addEventListener('click', () => {
        const optName = btn.dataset.option;
        const optVal = btn.dataset.value;
        selected[optName] = optVal;

        const grid = btn.closest('.md-swatch-grid');
        grid.querySelectorAll('.md-swatch-btn').forEach(b => b.classList.remove('active'));
        btn.classList.add('active');

        updateVariant();
        buildBulkPanel();
        filterImagesByVariant();
      });
    });
  }

  // ── IMAGE FILTERING BY VARIANT ────────────────────────────

  function filterImagesByVariant() {
    var filterOption = swatchOption || null;
    if (!filterOption) return;

    var filterValue = selected[filterOption];
    if (!filterValue) return;

    var thumbRow = document.getElementById('md-thumb-row');
    if (!thumbRow) return;

    var allThumbs = thumbRow.querySelectorAll('.md-thumb');

    // Determine which option key (option1/option2/option3) is the swatch
    var swatchIdx = options.indexOf(filterOption);
    var swatchKey = 'option' + (swatchIdx + 1);

    // Build color → primary image URL map from variant data
    var colorToUrl = {};
    variants.forEach(function (v) {
      var color = v[swatchKey];
      if (color && v.featured_image && v.featured_image.src && !colorToUrl[color]) {
        colorToUrl[color] = v.featured_image.src.split('?')[0];
      }
    });

    // Reverse map: primary URL → color (exact match)
    var urlToColor = {};
    for (var c in colorToUrl) { urlToColor[colorToUrl[c]] = c; }

    // Build color slug map for filename-based fallback matching.
    // Handles products with multiple images per color (e.g. gift tags
    // with 3 photos each) where only the primary image is the variant's
    // featured_image. Secondary images share the color name in filename.
    // Sort longest slug first so "LIGHT-PINK" matches before "LIGHT".
    var allColors = Object.keys(colorToUrl);
    var slugEntries = allColors.map(function (col) {
      return [col, col.replace(/\s+/g, '-')];
    }).sort(function (a, b) { return b[1].length - a[1].length; });

    // Match a thumbnail URL to its color (or null for universal)
    function matchThumbColor(thumbBaseUrl) {
      // 1. Exact URL match (fast path — single-image-per-color products)
      if (urlToColor[thumbBaseUrl]) return urlToColor[thumbBaseUrl];
      // 2. Filename-based color slug match (multi-image products)
      var filename = thumbBaseUrl.split('/').pop().toUpperCase();
      for (var i = 0; i < slugEntries.length; i++) {
        var slug = slugEntries[i][1];
        var re = new RegExp('[-_]' + slug.replace(/-/g, '[-_]') + '[-_.]');
        if (re.test('-' + filename)) return slugEntries[i][0];
      }
      return null; // universal image (lifestyle shot, etc.)
    }

    var firstVisible = null;
    var firstColorMatch = null;
    var filterLower = filterValue.toLowerCase();

    allThumbs.forEach(function (thumb) {
      var thumbBaseUrl = (thumb.dataset.src || '').split('?')[0];
      var thumbColor = matchThumbColor(thumbBaseUrl);
      var isVariantMatch = thumbColor && thumbColor.toLowerCase() === filterLower;
      var isUniversal = !thumbColor;

      if (isVariantMatch || isUniversal) {
        thumb.style.display = '';
        if (!firstVisible) firstVisible = thumb;
        if (isVariantMatch && !firstColorMatch) firstColorMatch = thumb;
      } else {
        thumb.style.display = 'none';
        thumb.classList.remove('active');
      }
    });

    // Prefer color-matched image for hero; fall back to first visible
    var heroThumb = firstColorMatch || firstVisible;

    // ── Variant-level featured_image override ──
    // For combo products (Color + Message), the full variant's featured_image
    // is more specific than the swatch-only match above. Check the current
    // variant and use its featured_image if available.
    var currentVariant = findVariant();
    if (currentVariant && currentVariant.featured_image && currentVariant.featured_image.src) {
      var variantImgBase = currentVariant.featured_image.src.split('?')[0];
      allThumbs.forEach(function (t) {
        if (t.style.display !== 'none') {
          var tBase = (t.dataset.src || '').split('?')[0];
          if (tBase === variantImgBase) heroThumb = t;
        }
      });
    }

    if (heroThumb) {
      allThumbs.forEach(function (t) { t.classList.remove('active'); });
      heroThumb.classList.add('active');
      var mainImg = document.getElementById('md-main-img');
      if (mainImg && heroThumb.dataset.src) {
        var preload = new Image();
        preload.onload = function () {
          mainImg.style.opacity = '0';
          setTimeout(function () {
            mainImg.src = heroThumb.dataset.src;
            mainImg.style.opacity = '1';
          }, 150);
        };
        preload.src = heroThumb.dataset.src;
      }
    }
  }

  // ── QUANTITY SELECTOR ─────────────────────────────────────

  function bindQtySelect() {
    const qtySelect = document.getElementById('md-qty-select');
    if (!qtySelect || !qtyOptionName) return;

    qtySelect.addEventListener('change', () => {
      selected[qtyOptionName] = qtySelect.value;
      updateVariant();
      highlightBulkRow();
    });
  }

  // ── VARIANT RESOLUTION ────────────────────────────────────

  function findVariant() {
    return variants.find(v => {
      return options.every((name, i) => {
        return v['option' + (i + 1)] === selected[name];
      });
    });
  }

  function getQtyVariantsForCurrentSelection() {
    if (!qtyOptionName) return variants;

    return variants.filter(v => {
      return options.every((name, i) => {
        if (name === qtyOptionName) return true;
        return v['option' + (i + 1)] === selected[name];
      });
    });
  }

  function updateVariant() {
    const variant = findVariant();
    if (!variant) return;

    // Update hidden input
    const variantIdInput = document.getElementById('md-variant-id');
    if (variantIdInput) variantIdInput.value = variant.id;

    // Update total (price lives only in subtotal now)
    updateTotal(variant);

    // Update URL
    const url = new URL(window.location);
    url.searchParams.set('variant', variant.id);
    window.history.replaceState({}, '', url);

    // Update add to cart button state
    const atcBtn = document.getElementById('md-atc-btn');
    if (atcBtn) {
      atcBtn.disabled = !variant.available;
    }
    const customizeBtn = document.getElementById('md-customize-btn');
    if (customizeBtn) {
      customizeBtn.disabled = !variant.available;
    }
    const helpBtn = document.querySelector('[data-md-design-help-open]');
    if (helpBtn) {
      helpBtn.disabled = !variant.available;
    }
  }

  function updateTotal(variant) {
    const totalEl = document.getElementById('md-total');
    const savedEl = document.getElementById('md-total-saved');

    if (!variant) return;

    // Variant price IS the total (e.g. 20 riders at $225.60 = variant price $225.60)
    const total = variant.price / 100;
    if (totalEl) totalEl.textContent = formatMoney(total);

    // Calculate savings vs buying at the base (lowest qty) per-unit rate
    if (savedEl) {
      const baseVariants = getQtyVariantsForCurrentSelection();
      if (baseVariants.length > 1 && qtyOptionName) {
        const qtyIdx = options.indexOf(qtyOptionName);

        // Base variant: get its total price and qty to find per-unit rate
        const baseTotal = baseVariants[0].price / 100;
        const baseQty = parseInt(baseVariants[0]['option' + (qtyIdx + 1)], 10) || 1;
        const baseUnitPrice = baseTotal / baseQty;

        // Current variant qty
        const currentQty = parseInt(variant['option' + (qtyIdx + 1)], 10) || 1;
        const wouldHavePaid = baseUnitPrice * currentQty;
        const savedAmt = wouldHavePaid - total;

        if (savedAmt > 0.01) {
          savedEl.textContent = 'You save ' + formatMoney(savedAmt);
          savedEl.classList.add('visible');
        } else {
          savedEl.classList.remove('visible');
        }
      } else {
        savedEl.classList.remove('visible');
      }
    }
  }

  // ── BULK PRICING PANEL ────────────────────────────────────

  function pluralizeUnit(count) {
    if (!productUnit) return '';
    const num = parseInt(count, 10);
    if (num === 1) return ' ' + productUnit;
    if (productUnit.endsWith('s') || productUnit.endsWith('x') || productUnit.endsWith('ch') || productUnit.endsWith('sh')) {
      return ' ' + productUnit + 'es';
    }
    return ' ' + productUnit + 's';
  }

  function buildBulkPanel() {
    const panel = document.getElementById('md-bulk-panel');
    if (!panel || !qtyOptionName) return;

    const qtyVariants = getQtyVariantsForCurrentSelection();
    if (qtyVariants.length <= 1) {
      panel.innerHTML = '';
      return;
    }

    const qtyIdx = options.indexOf(qtyOptionName);

    // Build entries — variant price is the TOTAL, so derive per-unit price
    const entries = qtyVariants.map(v => {
      const num = parseInt(v['option' + (qtyIdx + 1)], 10) || 1;
      const totalPrice = v.price / 100;
      return {
        qtyVal: v['option' + (qtyIdx + 1)],
        num: num,
        price: totalPrice / num  // per-unit price for display
      };
    });
    const basePrice = entries[0].price; // per-unit price at lowest qty

    // Collapse consecutive same-price entries into tiers
    const tiers = [];
    let i = 0;
    while (i < entries.length) {
      const tier = {
        startVal: entries[i].qtyVal,
        startNum: entries[i].num,
        endVal: entries[i].qtyVal,
        endNum: entries[i].num,
        price: entries[i].price,
        variants: [entries[i].qtyVal]
      };
      while (i + 1 < entries.length && entries[i + 1].price === tier.price) {
        i++;
        tier.endVal = entries[i].qtyVal;
        tier.endNum = entries[i].num;
        tier.variants.push(entries[i].qtyVal);
      }
      tiers.push(tier);
      i++;
    }

    let html = '';
    tiers.forEach((tier, idx) => {
      const price = tier.price;
      const isRange = tier.variants.length > 1;
      const isLast = idx === tiers.length - 1;
      const isActive = tier.variants.includes(selected[qtyOptionName]);

      let saveHtml = '';
      if (idx === 0) {
        saveHtml = '<span class="md-bulk-save empty">\u00a0</span>';
      } else {
        const pct = Math.round((1 - price / basePrice) * 100);
        if (pct > 0) {
          saveHtml = '<span class="md-bulk-save">Save ' + pct + '%</span>';
        } else {
          saveHtml = '<span class="md-bulk-save empty">\u00a0</span>';
        }
      }

      let qtyLabel;
      if (isRange) {
        if (isLast) {
          qtyLabel = tier.startNum + '+';
        } else {
          qtyLabel = tier.startNum + ' \u2013 ' + tier.endNum;
        }
        if (productUnit) qtyLabel += pluralizeUnit(2);
      } else {
        if (!isNaN(tier.startNum) && productUnit) {
          qtyLabel = tier.startNum + pluralizeUnit(tier.startNum);
        } else {
          qtyLabel = tier.startVal;
        }
      }

      // Check if this tier contains the recommended qty
      const isRecommended = recommendedQty && tier.variants.includes(recommendedQty);

      html += '<div class="md-bulk-row' + (isActive ? ' active' : '') + (isRecommended ? ' recommended' : '') + '" data-qty-value="' + escapeAttr(tier.startVal) + '" data-tier-values="' + escapeAttr(tier.variants.join(',')) + '">'
        + (isRecommended ? '<span class="md-bulk-badge">Most Popular</span>' : '')
        + '<span class="md-bulk-qty">' + qtyLabel + '</span>'
        + '<span class="md-bulk-price">' + formatMoney(price) + ' ea</span>'
        + saveHtml
        + '</div>';
    });

    panel.innerHTML = html;

    // Bind click on bulk rows
    panel.querySelectorAll('.md-bulk-row').forEach(row => {
      row.addEventListener('click', () => {
        const val = row.dataset.qtyValue;
        selected[qtyOptionName] = val;

        const qtySelect = document.getElementById('md-qty-select');
        if (qtySelect) {
          const option = qtySelect.querySelector('option[value="' + CSS.escape(val) + '"]');
          if (option) qtySelect.value = val;
        }

        updateVariant();
        highlightBulkRow();
      });
    });
  }

  function highlightBulkRow() {
    const panel = document.getElementById('md-bulk-panel');
    if (!panel) return;

    const currentVal = selected[qtyOptionName];
    panel.querySelectorAll('.md-bulk-row').forEach(row => {
      const tierValues = (row.dataset.tierValues || '').split(',');
      if (tierValues.includes(currentVal)) {
        row.classList.add('active');
      } else {
        row.classList.remove('active');
      }
    });
  }

  // ── THUMBNAILS ────────────────────────────────────────────

  function bindThumbnails() {
    document.querySelectorAll('.md-thumb').forEach(thumb => {
      thumb.addEventListener('click', () => {
        document.querySelectorAll('.md-thumb').forEach(t => t.classList.remove('active'));
        thumb.classList.add('active');

        const mainImg = document.getElementById('md-main-img');
        if (mainImg && thumb.dataset.src) {
          const preload = new Image();
          preload.onload = function () {
            mainImg.style.opacity = '0';
            setTimeout(function () {
              mainImg.src = thumb.dataset.src;
              mainImg.style.opacity = '1';
            }, 150);
          };
          preload.src = thumb.dataset.src;
        }
      });
    });
  }

  // ── TABS ──────────────────────────────────────────────────

  function bindTabs() {
    document.querySelectorAll('.md-tab-btn').forEach(btn => {
      btn.addEventListener('click', () => {
        const target = btn.dataset.tab;
        const section = btn.closest('.md-tabs-section');
        if (!section) return;

        section.querySelectorAll('.md-tab-btn').forEach(b => b.classList.remove('active'));
        section.querySelectorAll('.md-tab-panel').forEach(p => p.classList.remove('active'));

        btn.classList.add('active');
        const panel = section.querySelector('#' + target);
        if (panel) panel.classList.add('active');
      });
    });
  }

  // ── FAQ ───────────────────────────────────────────────────

  function bindFaq() {
    document.querySelectorAll('.md-faq-q').forEach(q => {
      q.addEventListener('click', () => {
        const item = q.closest('.md-faq-item');
        if (item) item.classList.toggle('open');
      });
    });
  }

  // ── HELPERS ───────────────────────────────────────────────

  function formatMoney(amount) {
    return '$' + amount.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function escapeAttr(str) {
    return String(str).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/'/g, '&#39;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }

  function tryParse(str) {
    try { return JSON.parse(str); } catch (e) { return {}; }
  }

  // ── MOBILE ENHANCEMENTS (≤ 768px) ──────────────────────────

  function isMobile() { return window.innerWidth <= 768; }

  function initMobile() {
    if (!isMobile()) return;
    repositionVariantPicker();
    initSwipeDots();
    initBulkToggle();
    initStickyAtc();
  }

  // On mobile, move the primary variant picker (color swatch or style grid)
  // directly under the hero image (i.e. to the top of the product column,
  // above the category label and the title).
  function repositionVariantPicker() {
    // Prefer swatch picker (color). Fall back to first style grid.
    var grid = document.querySelector('.md-swatch-grid') || document.querySelector('.md-style-grid');
    if (!grid) return;
    // Anchor: first child of the product column (category → fall back to title).
    var anchor = document.querySelector('.md-category') || document.querySelector('.md-title');
    if (!anchor) return;
    // The matching section: the preceding md-sec-label + the grid + the following md-divider.
    var label = grid.previousElementSibling;
    var divider = grid.nextElementSibling;
    if (label && label.classList.contains('md-sec-label')) {
      anchor.parentNode.insertBefore(label, anchor);
    }
    anchor.parentNode.insertBefore(grid, anchor);
    if (divider && divider.classList && divider.classList.contains('md-divider')) {
      anchor.parentNode.insertBefore(divider, anchor);
    }
  }

  // ── 1. HERO SWIPE + DOT INDICATORS ────────────────────────

  var swipeCurrentIndex = 0;
  var swipeImages = []; // [{src, thumbEl}]

  function initSwipeDots() {
    var thumbRow = document.getElementById('md-thumb-row');
    if (!thumbRow) return;

    var thumbs = thumbRow.querySelectorAll('.md-thumb');
    swipeImages = [];
    thumbs.forEach(function (t) {
      if (t.style.display !== 'none') {
        swipeImages.push({ src: t.dataset.src, thumbEl: t });
      }
    });
    if (swipeImages.length < 2) return;

    // Build dot container
    var imageCol = document.querySelector('.md-image-col');
    if (!imageCol) return;
    // Remove old dots if exist
    var oldDots = imageCol.querySelector('.md-swipe-dots');
    if (oldDots) oldDots.remove();

    var dotContainer = document.createElement('div');
    dotContainer.className = 'md-swipe-dots' + (swipeImages.length > 12 ? ' many' : '');

    swipeImages.forEach(function (img, i) {
      var dot = document.createElement('button');
      dot.className = 'md-swipe-dot' + (i === 0 ? ' active' : '');
      dot.setAttribute('aria-label', 'Image ' + (i + 1));
      dot.addEventListener('click', function () { swipeTo(i); });
      dotContainer.appendChild(dot);
    });

    // Insert after .md-main-image
    var mainImageWrap = imageCol.querySelector('.md-main-image');
    if (mainImageWrap && mainImageWrap.nextSibling) {
      imageCol.insertBefore(dotContainer, mainImageWrap.nextSibling);
    } else {
      imageCol.appendChild(dotContainer);
    }

    // Touch swipe on hero
    var heroWrap = document.querySelector('.md-main-image');
    if (heroWrap) {
      var touchStartX = 0;
      var touchEndX = 0;
      heroWrap.addEventListener('touchstart', function (e) {
        touchStartX = e.changedTouches[0].screenX;
      }, { passive: true });
      heroWrap.addEventListener('touchend', function (e) {
        touchEndX = e.changedTouches[0].screenX;
        var diff = touchStartX - touchEndX;
        if (Math.abs(diff) > 40) {
          if (diff > 0 && swipeCurrentIndex < swipeImages.length - 1) {
            swipeTo(swipeCurrentIndex + 1);
          } else if (diff < 0 && swipeCurrentIndex > 0) {
            swipeTo(swipeCurrentIndex - 1);
          }
        }
      }, { passive: true });
    }

    swipeCurrentIndex = 0;
  }

  function swipeTo(index) {
    if (index < 0 || index >= swipeImages.length) return;
    swipeCurrentIndex = index;

    var mainImg = document.getElementById('md-main-img');
    if (mainImg && swipeImages[index]) {
      var swipePreload = new Image();
      swipePreload.onload = function () {
        mainImg.style.opacity = '0';
        setTimeout(function () {
          mainImg.src = swipeImages[index].src;
          mainImg.style.opacity = '1';
        }, 120);
      };
      swipePreload.src = swipeImages[index].src;
    }

    // Update dots
    var dots = document.querySelectorAll('.md-swipe-dot');
    dots.forEach(function (d, i) {
      d.classList.toggle('active', i === index);
    });

    // Scroll active dot into view if overflowing
    var activeDot = dots[index];
    if (activeDot && activeDot.parentElement.classList.contains('many')) {
      activeDot.scrollIntoView({ inline: 'center', behavior: 'smooth', block: 'nearest' });
    }
  }

  // When filterImagesByVariant runs, rebuild dots with visible thumbs only
  var _origFilterFn = filterImagesByVariant;
  filterImagesByVariant = function () {
    _origFilterFn();
    if (isMobile()) {
      // Rebuild swipe images from currently visible thumbs
      var thumbRow = document.getElementById('md-thumb-row');
      if (!thumbRow) return;
      var thumbs = thumbRow.querySelectorAll('.md-thumb');
      swipeImages = [];
      thumbs.forEach(function (t) {
        if (t.style.display !== 'none') {
          swipeImages.push({ src: t.dataset.src, thumbEl: t });
        }
      });
      // Rebuild dots
      var dotContainer = document.querySelector('.md-swipe-dots');
      if (dotContainer) {
        dotContainer.innerHTML = '';
        dotContainer.className = 'md-swipe-dots' + (swipeImages.length > 12 ? ' many' : '');
        swipeImages.forEach(function (img, i) {
          var dot = document.createElement('button');
          dot.className = 'md-swipe-dot' + (i === 0 ? ' active' : '');
          dot.setAttribute('aria-label', 'Image ' + (i + 1));
          dot.addEventListener('click', function () { swipeTo(i); });
          dotContainer.appendChild(dot);
        });
      }
      swipeCurrentIndex = 0;
    }
  };

  // ── 2. COLLAPSIBLE BULK PRICING PANEL ─────────────────────

  function initBulkToggle() {
    var panel = document.getElementById('md-bulk-panel');
    if (!panel) return;

    // Only if not already toggled
    if (document.querySelector('.md-bulk-toggle')) return;

    // Create toggle button
    var toggle = document.createElement('button');
    toggle.type = 'button';
    toggle.className = 'md-bulk-toggle';
    toggle.innerHTML = '<span>View bulk pricing</span><svg class="md-bulk-toggle-chevron" width="14" height="14" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M4 6l4 4 4-4"/></svg>';

    // Insert before panel
    panel.parentNode.insertBefore(toggle, panel);

    // Start collapsed
    panel.classList.add('collapsed');

    toggle.addEventListener('click', function () {
      toggle.classList.toggle('open');
      panel.classList.toggle('collapsed');
      var label = toggle.querySelector('span');
      if (toggle.classList.contains('open')) {
        label.textContent = 'Hide bulk pricing';
      } else {
        label.textContent = 'View bulk pricing';
      }
    });
  }

  // ── 3. STICKY ADD-TO-CART BAR ─────────────────────────────

  function initStickyAtc() {
    // Don't create if already exists
    if (document.querySelector('.md-sticky-atc')) return;

    var atcBtn = document.getElementById('md-atc-btn');
    var customizeBtn = document.getElementById('md-customize-btn');
    // Mirror the primary CTA: Add to Cart wins when both exist (optional-
    // customize products), Customize wins on customizable-only products
    // where #md-atc-btn isn't rendered.
    var targetBtn = atcBtn || customizeBtn;
    if (!targetBtn) return;

    // Create sticky bar — price + savings on left, button on right
    var bar = document.createElement('div');
    bar.className = 'md-sticky-atc';

    var info = document.createElement('div');
    info.className = 'md-sticky-atc-info';

    // Variant label (e.g. "WHITE") above the price
    var variantLabel = document.createElement('div');
    variantLabel.className = 'md-sticky-atc-variant';
    variantLabel.id = 'md-sticky-variant';
    if (swatchOption && selected[swatchOption]) {
      variantLabel.textContent = selected[swatchOption];
    }

    var priceRow = document.createElement('div');
    priceRow.className = 'md-sticky-atc-price-row';

    var priceEl = document.createElement('div');
    priceEl.className = 'md-sticky-atc-price';
    priceEl.id = 'md-sticky-price';

    // Initialize with current variant price instead of "--"
    var initVariant = findVariant();
    if (initVariant) {
      priceEl.textContent = formatMoney(initVariant.price / 100);
    }

    var savingsEl = document.createElement('span');
    savingsEl.className = 'md-sticky-atc-savings';
    savingsEl.id = 'md-sticky-savings';

    priceRow.appendChild(priceEl);
    priceRow.appendChild(savingsEl);
    info.appendChild(variantLabel);
    info.appendChild(priceRow);
    bar.appendChild(info);

    var stickyBtn = document.createElement('button');
    stickyBtn.type = 'button';
    stickyBtn.className = 'md-sticky-atc-btn';
    if (targetBtn === atcBtn) {
      stickyBtn.innerHTML = '<svg width="14" height="14" viewBox="0 0 16 16" fill="none" stroke="white" stroke-width="1.5" stroke-linecap="round"><path d="M2 2h2l2 8h7l1.5-5H5.5"/><circle cx="7.5" cy="13" r="1.2" fill="white" stroke="none"/></svg> Add to Cart';
    } else {
      stickyBtn.innerHTML = '<svg width="14" height="14" viewBox="0 0 16 16" fill="none" stroke="white" stroke-width="2" stroke-linejoin="round"><path d="M11 2l3 3-8 8H3v-3l8-8z"/></svg> Customize';
    }
    stickyBtn.addEventListener('click', function () {
      targetBtn.click();
    });
    bar.appendChild(stickyBtn);

    document.body.appendChild(bar);

    // Show/hide based on scroll position — show when main ATC is out of view.
    // No rAF/IntersectionObserver: both have edge cases on iOS Safari
    // (bfcache restore, background tabs, orientation changes). A plain
    // synchronous handler is the most reliable option and the work is trivial.
    var _updateStickyVisibility = function () {
      // Primary check: main ATC button is above the viewport top.
      var rect = targetBtn.getBoundingClientRect();
      var btnAboveViewport = rect.bottom <= 0;
      // Fallback: if for any reason the button rect is stale or targetBtn is
      // disconnected, fall back to a fixed scroll threshold so the bar still
      // appears once the user is clearly deep into the page.
      var scrolledFarEnough = (window.pageYOffset || document.documentElement.scrollTop || 0) > 600;
      bar.classList.toggle('visible', btnAboveViewport || scrolledFarEnough);
    };
    _updateStickyVisibility();
    // Attach to both window AND document — Shopify preview frames + iOS Safari
    // sometimes route scroll through different contexts.
    window.addEventListener('scroll', _updateStickyVisibility, { passive: true });
    document.addEventListener('scroll', _updateStickyVisibility, { passive: true });
    window.addEventListener('resize', _updateStickyVisibility);
    window.addEventListener('orientationchange', _updateStickyVisibility);
    window.addEventListener('load', _updateStickyVisibility);
    window.addEventListener('pageshow', _updateStickyVisibility);
    setTimeout(_updateStickyVisibility, 500);
    setTimeout(_updateStickyVisibility, 1500);

    // Update price and savings whenever variant changes
    var _origUpdateTotal = updateTotal;
    updateTotal = function (variant) {
      _origUpdateTotal(variant);
      if (variant) {
        var stickyPrice = document.getElementById('md-sticky-price');
        if (stickyPrice) {
          stickyPrice.textContent = formatMoney(variant.price / 100);
        }
        // Update variant label on sticky bar
        var stickyVariant = document.getElementById('md-sticky-variant');
        if (stickyVariant && swatchOption && selected[swatchOption]) {
          stickyVariant.textContent = selected[swatchOption];
        }
        // Show bulk savings in sticky bar
        var stickySavings = document.getElementById('md-sticky-savings');
        if (stickySavings && qtyOptionName) {
          var baseVariants = getQtyVariantsForCurrentSelection();
          if (baseVariants.length > 1) {
            var qtyIdx = options.indexOf(qtyOptionName);
            var baseTotal = baseVariants[0].price / 100;
            var baseQty = parseInt(baseVariants[0]['option' + (qtyIdx + 1)], 10) || 1;
            var baseUnitPrice = baseTotal / baseQty;
            var total = variant.price / 100;
            var currentQty = parseInt(variant['option' + (qtyIdx + 1)], 10) || 1;
            var wouldHavePaid = baseUnitPrice * currentQty;
            var savedAmt = wouldHavePaid - total;
            if (savedAmt > 0.01) {
              stickySavings.textContent = 'Save ' + formatMoney(savedAmt);
            } else {
              stickySavings.textContent = '';
            }
          } else {
            stickySavings.textContent = '';
          }
        }
      }
    };
  }

  // ── LAUNCH ────────────────────────────────────────────────

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); initMobile(); });
  } else {
    init();
    initMobile();
  }

})();
